import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	saveAsTemplateNonFinal: {
		id: 'navigation-project-action-menu.save-as-template.save-as-template-non-final',
		defaultMessage: 'Save as template',
		description: 'The label for the link that navigates to the save as template screen',
	},
});
